module.exports = __webpack_public_path__ + "static/media/home_bg.5d2650f7.png";